(() => {
  // Independent close handling stays active even if a non-cart widget fails during initialization.
  if (!window.__hbCartCloseRepairV1) {
    window.__hbCartCloseRepairV1 = true;
    const closeOpenCart = () => {
      const panel = document.querySelector('[data-hb-cart-drawer]');
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.documentElement.classList.remove('hb-cart-open');
      document.body.classList.remove('hb-cart-open');
    };
    document.addEventListener('click', (event) => {
      if (!event.target.closest?.('[data-hb-cart-close]')) return;
      event.preventDefault();
      closeOpenCart();
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeOpenCart();
    });
  }

  const roots = document.querySelectorAll('[data-hb-root]:not([data-hb-ready])');

  roots.forEach((root) => {
    root.dataset.hbReady = 'true';
    const variantsNode = root.querySelector('[data-hb-variants]') || document.querySelector('[data-hb-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const defaultOnly = root.dataset.hbDefaultOnly === 'true';
    const christmasProduct = root.dataset.hbChristmasProduct === 'true';
    const miniVinyl = root.dataset.hbMiniVinyl === 'true';
    const gameProjector = root.dataset.hbGameProjector === 'true';
    const butterflyNecklace = root.dataset.hbButterflyNecklace === 'true';
    const kneeBrace = root.dataset.hbKneeBrace === 'true';
    const heatedCushion = !!root.querySelector('[data-hb-heated-cushion="true"]');
    const colorOnlyBundle = !!root.querySelector('[data-hb-knee-color-only="true"]');
    const directVariantCards = gameProjector || (butterflyNecklace && !kneeBrace);
    const variantCardInputs = [...root.querySelectorAll('[data-hb-game-variant], [data-hb-butterfly-variant]')];
    const christmasMystery = christmasProduct || miniVinyl;
    const christmasGiftUrl = root.dataset.hbChristmasGiftUrl;
    const form = root.querySelector('[data-hb-product-form]');
    const variantInput = root.querySelector('[data-hb-variant-id]');
    const colorInputs = [...root.querySelectorAll('[data-hb-color]')];
    const colorSelect = colorInputs.find((input) => input.tagName === 'SELECT');
    const sizeInputs = [...root.querySelectorAll('[data-hb-size]')];
    const error = root.querySelector('[data-hb-error]');
    const addButton = root.querySelector('[data-hb-add]');
    const drawer = root.querySelector('[data-hb-cart-drawer]') || document.querySelector('[data-hb-cart-drawer]');
    const addOnVariants = {
      mystery: Number(root.dataset.hbMysteryVariant),
      shipping: Number(root.dataset.hbShippingVariant),
    };
    let shippingOptedOut = false;

    const activeDrawer = () => document.querySelector('[data-hb-cart-drawer]') || drawer;
    const cartNode = (selector) => activeDrawer()?.querySelector(selector) || document.querySelector('[data-hb-cart-drawer] '+selector) || root.querySelector(selector);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });

    const formatMoney = (cents) => money.format(Number(cents || 0) / 100);
    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const selectedColor = () => colorInputs.find((input) => input.checked)?.value || colorSelect?.value;
    const selectedSize = () => sizeInputs.find((input) => input.checked)?.value;
    const findVariant = (color, size) => variants.find((variant) => variant.option1 === color && ((miniVinyl && !kneeBrace) || variant.option2 === size));
    const selectedCardVariant = () => variants.find((variant) => String(variant.id) === variantCardInputs.find((input) => input.checked)?.value);
    const singleProductVariant = () => {
      const variant = variants.find((item) => String(item.id) === String(variantInput?.value)) || variants.find((item) => item.available) || variants[0];
      if (variant) return variant;
      const id = Number(root.dataset.hbCurrentVariantId || variantInput?.value);
      if (!id) return null;
      return {
        id,
        price: Number(root.dataset.hbCurrentVariantPrice || 0),
        compare_at_price: Number(root.dataset.hbCurrentVariantCompare || 0),
        available: root.dataset.hbCurrentVariantAvailable === 'true',
      };
    };

    const showError = (message) => {
      const target = root.querySelector('[data-hb-error]') || document.querySelector('[data-hb-error]');
      if (!target) return;
      target.textContent = message;
      target.hidden = !message;
    };

    const showVariantImage = (variant) => {
      const source = variant?.featured_image?.src;
      if (!source) return;
      const filename = source.split('/').pop().split('?')[0];
      const images = [...root.querySelectorAll('.hb-gallery__image')];
      const index = images.findIndex((image) => image.currentSrc.includes(filename) || image.src.includes(filename));
      if (index < 0) return;
      images[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      root.querySelectorAll('[data-hb-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', Number(thumb.dataset.hbThumb) === index));
    };

    const kneeVariant = (row) => (heatedCushion || colorOnlyBundle)
      ? variants.find((variant) => variant.option1 === row.querySelector('[data-hb-knee-color]')?.value)
      : findVariant(row.querySelector('[data-hb-knee-color]')?.value, row.querySelector('[data-hb-knee-size]')?.value);
    const syncKnee = () => {
      const bundles = [...root.querySelectorAll('[data-hb-knee-bundle]')];
      const selected = bundles.find((bundle) => bundle.querySelector('input[name="hb_knee_bundle"]')?.checked);
      let selectedVariants = [];
      let selectedPrice = 0;
      let selectedCompare = 0;
      for (const bundle of bundles) {
        const rows = [...bundle.querySelectorAll('[data-hb-knee-row]')];
        const bundleVariants = rows.map((row) => {
          const color = row.querySelector('[data-hb-knee-color]');
          const image = row.querySelector('[data-hb-knee-image]');
          const imageUrl = color?.selectedOptions[0]?.dataset.image;
          if (image && imageUrl) image.src = imageUrl;
          return kneeVariant(row);
        });
        const basePrice = bundleVariants.reduce((sum, variant) => sum + Number(variant?.price || 0), 0);
        const bundleSaving = Math.round(Number(bundle.dataset.hbKneeSavings || 0) * Number(window.Shopify?.currency?.rate || 1));
        const price = Math.max(0, basePrice - bundleSaving);
        const compare = bundle.dataset.hbKneeCompareTotal
          ? Math.round(Number(bundle.dataset.hbKneeCompareTotal) * Number(window.Shopify?.currency?.rate || 1))
          : bundleVariants.reduce((sum, variant) => sum + Number(variant?.compare_at_price || variant?.price || 0), 0);
        bundle.querySelector('[data-hb-knee-price]').textContent = formatMoney(price);
        const compareNode = bundle.querySelector('[data-hb-knee-compare]');
        if (compareNode) {
          compareNode.textContent = formatMoney(compare);
          compareNode.hidden = compare <= price;
        }
        bundle.classList.toggle('is-selected', bundle === selected);
        if (bundle === selected) {
          selectedVariants = bundleVariants;
          selectedPrice = price;
          selectedCompare = compare;
        }
      }
      const valid = selectedVariants.length > 0 && selectedVariants.every((variant) => variant?.available);
      if (selectedVariants[0]) {
        variantInput.value = selectedVariants[0].id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariants[0].id);
        window.history.replaceState({}, '', url);
      }
      root.querySelector('[data-hb-price]').textContent = formatMoney(selectedPrice);
      const compareNode = root.querySelector('[data-hb-compare]');
      if (compareNode) {
        compareNode.textContent = formatMoney(selectedCompare);
        compareNode.hidden = selectedCompare <= selectedPrice;
      }
      const saving = root.querySelector('[data-hb-save]');
      if (saving) {
        saving.hidden = selectedCompare <= selectedPrice;
        saving.textContent = `SAVE ${selectedCompare > selectedPrice ? Math.round((1 - selectedPrice / selectedCompare) * 100) : 0}%`;
      }
      addButton.disabled = !valid;
      showError(valid ? '' : colorOnlyBundle ? 'Please choose an available color for each item.' : heatedCushion ? 'Please choose an available color and plug for each item.' : 'Please choose an available color and size for each item.');
    };

    const syncVariant = () => {
      if (kneeBrace) return syncKnee();
      const color = selectedColor();
      const size = selectedSize();
      const variant = directVariantCards ? selectedCardVariant() : (defaultOnly || christmasProduct) ? singleProductVariant() : findVariant(color, size);
      const colorLabel = root.querySelector('[data-hb-color-label]');
      const sizeLabel = root.querySelector('[data-hb-size-label]');
      if (colorLabel) colorLabel.textContent = color;
      if (sizeLabel) sizeLabel.textContent = size;

      if (!variant) {
        addButton.disabled = true;
        showError(butterflyNecklace ? 'Please select an available jewelry option.' : gameProjector ? 'Please select an available game edition.' : christmasProduct || defaultOnly ? 'This item is currently unavailable.' : miniVinyl ? 'This color is currently unavailable.' : 'This color and size combination is unavailable.');
        return;
      }

      variantInput.value = variant.id;
      root.querySelector('[data-hb-price]').textContent = formatMoney(variant.price);
      const compare = root.querySelector('[data-hb-compare]');
      if (compare) compare.textContent = formatMoney(variant.compare_at_price);
      if (directVariantCards) {
        if (compare) compare.hidden = !(variant.compare_at_price > variant.price);
        const saving = root.querySelector('[data-hb-save]');
        if (saving) {
          saving.hidden = !(variant.compare_at_price > variant.price);
          saving.textContent = `SAVE ${variant.compare_at_price > variant.price ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0}%`;
        }
      }
      addButton.disabled = !variant.available;
      showError(variant.available ? '' : 'This variant is currently sold out.');
      showVariantImage(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    colorInputs.forEach((input) => input.addEventListener('change', () => {
      if (miniVinyl) {
        const buyOneColor = root.querySelector('[data-hb-config="1"] [data-hb-item-color]');
        if (buyOneColor) buyOneColor.value = selectedColor();
      }
      syncVariant();
    }));
    if (miniVinyl) {
      root.querySelectorAll('[data-hb-item-color]').forEach((select) => select.addEventListener('change', () => {
        if (select.closest('[data-hb-config="1"]')) {
          const pill = colorInputs.find((input) => input.value === select.value);
          if (pill) pill.checked = true;
          syncVariant();
        }
        showError('');
      }));
    }
    sizeInputs.forEach((input) => input.addEventListener('change', syncVariant));
    variantCardInputs.forEach((input) => input.addEventListener('change', syncVariant));
    root.querySelectorAll('input[name="hb_knee_bundle"], [data-hb-knee-size], [data-hb-knee-color]').forEach((input) => input.addEventListener('change', syncKnee));

    root.querySelectorAll('[data-hb-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const image = root.querySelector(`[data-hb-gallery-image="${thumb.dataset.hbThumb}"]`);
        image?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        root.querySelectorAll('[data-hb-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const reviewTrack = root.querySelector('[data-hb-review-track]');
    const reviewSlides = [...root.querySelectorAll('[data-hb-review-slide]')];
    const reviewDots = [...root.querySelectorAll('[data-hb-review-dot]')];
    let activeReviewIndex = 0;
    const setActiveReview = (index) => {
      activeReviewIndex = index;
      reviewDots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goToReview = (index, behavior = 'smooth') => {
      const safeIndex = Math.max(0, Math.min(reviewSlides.length - 1, index));
      const left = safeIndex * reviewTrack.clientWidth;
      if (typeof reviewTrack.scrollTo === 'function') reviewTrack.scrollTo({ left, behavior });
      else reviewTrack.scrollLeft = left;
      setActiveReview(safeIndex);
    };

    reviewDots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        const index = Number(dot.dataset.hbReviewDot);
        goToReview(index);
      });
    });

    let reviewScrollFrame;
    reviewTrack.addEventListener('scroll', () => {
      window.cancelAnimationFrame(reviewScrollFrame);
      reviewScrollFrame = window.requestAnimationFrame(() => {
        const index = Math.max(0, Math.min(reviewSlides.length - 1, Math.round(reviewTrack.scrollLeft / reviewTrack.clientWidth)));
        setActiveReview(index);
      });
    }, { passive: true });

    window.addEventListener('resize', () => goToReview(activeReviewIndex, 'auto'));

    const supporterTrack = root.querySelector('[data-hb-supporter-track]');
    const supporterSlides = [...root.querySelectorAll('[data-hb-supporter-slide]')];
    const supporterDots = [...root.querySelectorAll('[data-hb-supporter-dot]')];
    let activeSupporterIndex = 0;
    const setActiveSupporter = (index) => {
      activeSupporterIndex = index;
      supporterDots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const goToSupporter = (index, behavior = 'smooth') => {
      if (!supporterTrack || !supporterSlides.length) return;
      const safeIndex = Math.max(0, Math.min(supporterSlides.length - 1, index));
      const slide = supporterSlides[safeIndex];
      const left = slide.offsetLeft - supporterTrack.offsetLeft;
      if (typeof supporterTrack.scrollTo === 'function') supporterTrack.scrollTo({ left, behavior });
      else supporterTrack.scrollLeft = left;
      setActiveSupporter(safeIndex);
    };
    supporterDots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        goToSupporter(Number(dot.dataset.hbSupporterDot));
      });
    });
    supporterTrack?.addEventListener('scroll', () => {
      const nearest = supporterSlides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - supporterTrack.scrollLeft - supporterTrack.offsetLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      setActiveSupporter(nearest.index);
    }, { passive: true });
    window.addEventListener('resize', () => goToSupporter(activeSupporterIndex, 'auto'));

    const ordinalDay = (day) => {
      const remainder = day % 100;
      if (remainder >= 11 && remainder <= 13) return `${day}th`;
      return `${day}${({ 1: 'st', 2: 'nd', 3: 'rd' })[day % 10] || 'th'}`;
    };
    const formatDeliveryDate = (offset) => {
      const date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + offset);
      const month = date.toLocaleString('en-US', { month: 'short' });
      return `${month} ${ordinalDay(date.getDate())}`;
    };
    root.querySelectorAll('[data-hb-delivery-date]').forEach((node) => {
      const start = Number(node.dataset.hbDeliveryStart || 0);
      const end = node.dataset.hbDeliveryEnd;
      node.textContent = end === undefined ? formatDeliveryDate(start) : `${formatDeliveryDate(start)} – ${formatDeliveryDate(Number(end))}`;
    });

    const bundleInputs = [...root.querySelectorAll('input[name="hb_bundle"]')];
    bundleInputs.forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('[data-hb-bundle]').forEach((bundle) => bundle.classList.remove('is-selected'));
        const bundle = input.closest('[data-hb-bundle]');
        if (!bundle) return;
        bundle.classList.add('is-selected');
        if (!miniVinyl) {
          bundle.querySelectorAll('[data-hb-item-size]').forEach((select) => { select.value = selectedSize(); });
          bundle.querySelectorAll('[data-hb-item-color]').forEach((select) => { select.value = selectedColor(); });
        }
      });
    });

    const selectedBundle = () => Number(kneeBrace ? root.querySelector('input[name="hb_knee_bundle"]:checked')?.value || 1 : bundleInputs.find((input) => input.checked)?.value || 1);
    const cartItems = () => {
      const quantity = selectedBundle();
      if (kneeBrace) {
        const bundle = root.querySelector(`[data-hb-knee-bundle="${quantity}"]`);
        return [...(bundle?.querySelectorAll('[data-hb-knee-row]') || [])].map((row) => {
          const variant = kneeVariant(row);
          return variant?.available ? { id: variant.id, quantity: 1, ...(heatedCushion ? { properties: { Plug: row.querySelector('[data-hb-knee-size]').value } } : {}) } : null;
        }).filter(Boolean);
      }
      if (butterflyNecklace) {
        const variant = selectedCardVariant();
        return variant?.available ? [{ id: variant.id, quantity: 1 }] : [];
      }
      if (gameProjector) {
        const variant = selectedCardVariant();
        if (!variant?.available) return [];
        const controllers = root.querySelector('[data-hb-game-bonus="controllers"]')?.checked;
        const games = root.querySelector('[data-hb-game-bonus="games"]')?.checked;
        return [{ id: variant.id, quantity: 1, properties: {
          'Free controllers': controllers ? '2 controllers included' : 'Not requested',
          'Free extra games': games ? '5,000 extra games included' : 'Not requested',
        } }];
      }
      if (defaultOnly || christmasProduct) {
        const variant = singleProductVariant();
        return variant?.available ? Array.from({ length: quantity }, () => ({ id: variant.id, quantity: 1 })) : [];
      }
      if (miniVinyl) {
        const configuration = root.querySelector(`[data-hb-config="${quantity}"]`);
        const rows = [...(configuration?.querySelectorAll('.hb-config-row') || [])];
        return rows.map((row) => {
          const variant = findVariant(row.querySelector('[data-hb-item-color]')?.value);
          return variant?.available ? { id: variant.id, quantity: 1 } : null;
        }).filter(Boolean);
      }
      if (quantity === 1) {
        const variant = findVariant(selectedColor(), selectedSize());
        return variant ? [{ id: variant.id, quantity: 1 }] : [];
      }

      const configuration = root.querySelector(`[data-hb-config="${quantity}"]`);
      return [...configuration.querySelectorAll('.hb-config-row')].map((row) => {
        const color = row.querySelector('[data-hb-item-color]').value;
        const size = row.querySelector('[data-hb-item-size]').value;
        const variant = findVariant(color, size);
        return variant ? { id: variant.id, quantity: 1 } : null;
      }).filter(Boolean);
    };

    const changeCartLine = async (key, quantity) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('Unable to update cart item.');
      await refreshCart();
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load the cart.');
      return response.json();
    };

    const isAddOnItem = (item) => Object.values(addOnVariants).includes(Number(item.variant_id));

    const setCartAddOn = async (name, checked) => {
      const variantId = addOnVariants[name];
      if (!variantId) throw new Error('This cart option is unavailable.');

      const cart = await fetchCart();
      const existing = cart.items.find((item) => Number(item.variant_id) === variantId);
      if (checked && !existing) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('Unable to add this cart option.');
      } else if (!checked && existing) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: existing.key, quantity: 0 }),
        });
        if (!response.ok) throw new Error('Unable to remove this cart option.');
      }
      await refreshCart();
    };

    const refreshCart = async () => {
      let cart = await fetchCart();
      let merchandiseItems = cart.items.filter((item) => !isAddOnItem(item));

      if (!merchandiseItems.length && cart.items.some(isAddOnItem)) {
        const updates = Object.fromEntries(cart.items.filter(isAddOnItem).map((item) => [item.key, 0]));
        const cleanup = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (cleanup.ok) {
          cart = await cleanup.json();
          merchandiseItems = cart.items.filter((item) => !isAddOnItem(item));
        }
      }

      root.querySelectorAll('[data-hb-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      const drawerCount = cartNode('[data-hb-drawer-count]');
      const drawerTotal = cartNode('[data-hb-cart-total]');
      const checkoutLink = cartNode('.hb-checkout-button');
      const ghostSwingQuantity = cart.items.reduce((quantity, item) =>
        quantity + (Number(item.product_id) === 15564844138867 ? Number(item.quantity) : 0), 0);
      const miniVinylQuantity = cart.items.reduce((quantity, item) =>
        quantity + (Number(item.product_id) === 15573784887667 ? Number(item.quantity) : 0), 0);
      const ghostBundle = ghostSwingQuantity >= 3
        ? { code: 'VELORAGHOSTBUNDLE3', savings: 1160 }
        : ghostSwingQuantity === 2 ? { code: 'VELORAGHOSTBUNDLE2', savings: 1280 } : null;
      const miniVinylBundle = miniVinylQuantity >= 3
        ? { code: 'VELORAMINIVINYL3', savings: 1160 }
        : miniVinylQuantity === 2 ? { code: 'VELORAMINIVINYL2', savings: 1280 } : null;
      const activeBundle = miniVinyl ? (miniVinylBundle || ghostBundle) : (ghostBundle || miniVinylBundle);
      const presentmentRate = Number(window.Shopify?.currency?.rate || 1);
      const bundleSavings = Math.round((activeBundle?.savings || 0) * presentmentRate);
      if (drawerCount) drawerCount.textContent = cart.item_count;
      if (drawerTotal) drawerTotal.textContent = formatMoney(Math.max(0, cart.total_price - bundleSavings));
      if (checkoutLink) {
        checkoutLink.href = activeBundle
          ? `/discount/${activeBundle.code}?redirect=%2Fcheckout`
          : '/checkout';
      }
      const comparisonSavings = cart.items.reduce((total, item) => {
        const variant = variants.find((candidate) => Number(candidate.id) === Number(item.variant_id));
        return total + (variant?.compare_at_price > variant?.price ? (variant.compare_at_price - variant.price) * item.quantity : 0);
      }, 0) + Number(cart.total_discount || 0) + bundleSavings;
      const savingsNode = cartNode('[data-hb-cart-savings]');
      if (savingsNode) savingsNode.textContent = comparisonSavings ? `−${formatMoney(comparisonSavings)}` : formatMoney(0);

      const shippingToggle = root.querySelector('[data-hb-cart-addon="shipping"]') || document.querySelector('[data-hb-cart-addon="shipping"]');
      if (shippingToggle) shippingToggle.checked = cart.items.some((item) => Number(item.variant_id) === addOnVariants.shipping);
      const body = cartNode('[data-hb-cart-body]');
      if (!body) throw new Error('The cart contents panel could not be found.');
      body.style.setProperty('background-color', '#fff', 'important');
      body.style.setProperty('color', '#111', 'important');
      body.style.setProperty('min-height', '0');
      const itemMarkup = merchandiseItems.map((item) => `
        <article class="hb-cart-item">
          <img src="${escapeHtml(item.image || '')}" alt="">
          <div class="hb-cart-item__content"><strong>${escapeHtml(item.product_title)}</strong><span>${escapeHtml(item.variant_title || '')}</span>${Object.entries(item.properties || {}).map(([name, value]) => `<span>${escapeHtml(name)}: ${escapeHtml(value)}</span>`).join('')}<div class="hb-cart-item__controls"><button type="button" data-hb-line-key="${escapeHtml(item.key)}" data-hb-line-quantity="${Math.max(0, item.quantity - 1)}">−</button><b>${item.quantity}</b><button type="button" data-hb-line-key="${escapeHtml(item.key)}" data-hb-line-quantity="${item.quantity + 1}">+</button><strong>${formatMoney(item.final_line_price)}</strong></div></div>
          <button type="button" class="hb-cart-item__remove" aria-label="Remove ${escapeHtml(item.product_title)}" data-hb-line-key="${escapeHtml(item.key)}" data-hb-line-quantity="0">×</button>
        </article>
      `).join('');
      const mysteryChecked = cart.items.some((item) => Number(item.variant_id) === addOnVariants.mystery);
      const mysteryGiftSize = miniVinyl ? 40 : 58;
      const mysteryIcon = christmasMystery
        ? `<img src="${escapeHtml(christmasGiftUrl)}" width="${mysteryGiftSize}" height="${mysteryGiftSize}" alt="" style="display:block;width:${mysteryGiftSize}px;height:${mysteryGiftSize}px;object-fit:contain">`
        : `<svg viewBox="0 0 64 64"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 23 32 15l18 8-18 9-18-9Zm0 0v21l18 9 18-10V23M32 32v21"></path><path fill="currentColor" d="M28.5 22.5c.2-3.4 2.3-5.5 5.7-5.5 3.3 0 5.6 1.8 5.6 4.8 0 2.3-1.3 3.7-3.2 4.9-1.8 1.1-2.5 1.9-2.5 3.6v.6h-4v-1c0-2.7 1-4.1 3-5.4 1.5-.9 2.2-1.5 2.2-2.6 0-1.1-.8-1.8-2-1.8-1.4 0-2.2.9-2.3 2.4h-2.5Zm3.6 10.2c1.5 0 2.6 1.1 2.6 2.5s-1.1 2.5-2.6 2.5-2.6-1.1-2.6-2.5 1.1-2.5 2.6-2.5Z"></path><text x="32" y="61" text-anchor="middle" fill="currentColor" font-family="Arial,sans-serif" font-size="6" font-weight="700" letter-spacing=".7">MYSTERY BOX</text></svg>`;
      const mysteryDescription = christmasMystery ? 'Get a Christmas surprise gift picked especially for you.' : 'Get a surprise spooky accessory picked just for you.';
      const mysteryMarkup = merchandiseItems.length ? `
        <label class="hb-mystery-gift">
          <span class="hb-mystery-gift__icon" aria-hidden="true">${mysteryIcon}</span>
          <span><strong>VELORA™ Mystery Box</strong><small>${mysteryDescription}</small></span>
          <b>$9.90</b>
          <input type="checkbox" data-hb-cart-addon="mystery" ${mysteryChecked ? 'checked' : ''}>
          <i class="hb-switch" aria-hidden="true"></i>
        </label>` : '';
      body.innerHTML = merchandiseItems.length ? itemMarkup + mysteryMarkup : '<p class="hb-cart-empty">Your cart is empty.</p>';

      body.querySelectorAll('[data-hb-line-key]').forEach((button) => {
        button.addEventListener('click', () => changeCartLine(button.dataset.hbLineKey, Number(button.dataset.hbLineQuantity)));
      });
      body.querySelectorAll('[data-hb-cart-addon]').forEach((checkbox) => {
        checkbox.addEventListener('change', async () => {
          checkbox.disabled = true;
          try {
            await setCartAddOn(checkbox.dataset.hbCartAddon, checkbox.checked);
          } catch (requestError) {
            checkbox.checked = !checkbox.checked;
            showError(requestError.message || 'Unable to update this cart option.');
          } finally {
            checkbox.disabled = false;
          }
        });
      });
      return cart;
    };

    const openDrawer = async () => {
      const currentDrawer = activeDrawer();
      if (!currentDrawer) throw new Error('Shopping cart panel was not found.');
      currentDrawer.classList.add('is-open');
      currentDrawer.setAttribute('aria-hidden', 'false');
      currentDrawer.querySelector('aside')?.style.setProperty('background-color', '#fff', 'important');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('hb-cart-open');
      document.body.classList.add('hb-cart-open');
      try {
        const cart = await refreshCart();
        const hasMerchandise = cart.items.some((item) => !isAddOnItem(item));
        const hasShipping = cart.items.some((item) => Number(item.variant_id) === addOnVariants.shipping);
        if (hasMerchandise && addOnVariants.shipping && !hasShipping && !shippingOptedOut) {
          await setCartAddOn('shipping', true);
        }
      } catch (requestError) {
        showError(requestError.message || 'Unable to load the cart.');
      }
    };

    const closeDrawer = () => {
      const currentDrawer = activeDrawer();
      currentDrawer?.classList.remove('is-open');
      currentDrawer?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.documentElement.classList.remove('hb-cart-open');
      document.body.classList.remove('hb-cart-open');
    };

    const isCartLink = (element) => {
      if (!element?.matches?.('a[href]')) return false;
      try {
        const target = new URL(element.href, window.location.origin);
        return target.origin === window.location.origin && target.pathname.replace(/\/$/, '') === '/cart';
      } catch (_) {
        return false;
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-hb-cart-open], a[href]');
      if (!trigger || (!trigger.matches('[data-hb-cart-open]') && !isCartLink(trigger))) return;
      event.preventDefault();
      openDrawer();
    });
    root.querySelectorAll('[data-hb-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    const shippingAddonToggle = root.querySelector('[data-hb-cart-addon="shipping"]') || document.querySelector('[data-hb-cart-addon="shipping"]');
    shippingAddonToggle?.addEventListener('change', async (event) => {
      const checkbox = event.target;
      checkbox.disabled = true;
      try {
        await setCartAddOn(checkbox.dataset.hbCartAddon, checkbox.checked);
        shippingOptedOut = !checkbox.checked;
      } catch (requestError) {
        checkbox.checked = !checkbox.checked;
        showError(requestError.message || 'Unable to update this cart option.');
      } finally {
        checkbox.disabled = false;
      }
    });

    let reservedSeconds = 5 * 60;
    const reservationClock = root.querySelector('[data-hb-reserved-time]');
    setInterval(() => {
      if (!drawer?.classList.contains('is-open')) return;
      reservedSeconds = reservedSeconds > 0 ? reservedSeconds - 1 : 5 * 60;
      reservationClock.textContent = `${String(Math.floor(reservedSeconds / 60)).padStart(2, '0')}:${String(reservedSeconds % 60).padStart(2, '0')}`;
    }, 1000);

    const addToCart = async (checkout) => {
      const items = cartItems();
      if (items.length !== selectedBundle()) {
        showError(colorOnlyBundle ? 'Please choose an available color for each item.' : heatedCushion ? 'Please choose an available color and plug for each item.' : kneeBrace ? 'Please choose an available color and size for each item.' : butterflyNecklace ? 'Please select an available jewelry option.' : gameProjector ? 'Please select an available game edition.' : miniVinyl ? 'Please choose an available color for every item.' : 'Please choose an available color and size for every item.');
        return;
      }

      showError('');
      addButton.disabled = true;
      const previousText = addButton.textContent;
      addButton.textContent = 'ADDING...';

      try {
        const groupedItems = [...items.reduce((byVariant, item) => {
          const groupingKey = heatedCushion ? JSON.stringify([item.id, item.properties?.Plug]) : item.id;
          const existing = byVariant.get(groupingKey);
          if (existing) existing.quantity += item.quantity;
          else byVariant.set(groupingKey, { ...item });
          return byVariant;
        }, new Map()).values()];
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: groupedItems }),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
        if (checkout) {
          window.location.href = '/checkout';
          return;
        }
        await openDrawer();
      } catch (requestError) {
        showError(requestError.message || 'Unable to add this item. Please try again.');
      } finally {
        addButton.disabled = false;
        addButton.textContent = previousText;
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart(false);
    });
    syncVariant();
  });
})();
